export const csrfToken = () => {
  let element: HTMLInputElement | null = document.querySelector('input#csrftoken')
  let csrf: string = ''
  if (element !== null) {
    csrf = element.value
  }
  return csrf
}
